@use 'sass:color';
@import 'vars';
@import 'mixins';

$horizontal-padding: 10px;
$vertical-padding: 12px;
$vertical-padding--small: 8px;
$gap: 10px;
$background: $white;
$background--selected: $secondary;
$border: $mid-grey;
$border--selected: $secondary;
$border--hover: $dark-grey;
$small-size: 35px;
$large-size: 45px;
$joined-border-radius: 4px;

.segmented-controls {
  display: flex;
  width: 100%;
  gap: $gap;

  &--joined {
    gap: 0;
    width: fit-content;
    white-space: nowrap;
    overflow: hidden;
  }

  &--softphone:not(&--joined) {
    height: 30px;

    button {
      font-size: $font-size-extra-small;
      font-weight: $font-weight-medium;
    }

    @include small-softphone {
      gap: 5px;
    }
  }

  &--square {
    width: fit-content;
    background: $background;
    box-shadow: 0 1px 2px rgb(0 0 0 / 5%);
  }

  &__option-wrapper {
    display: flex;
    flex: 1;
  }

  &__option {
    padding: $vertical-padding $horizontal-padding;
    background: $background;
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    border-radius: 20px;
    font-size: $font-size-normal;
    border: 1px solid $border;
    cursor: default;

    &:hover:not(&--selected):not(&--disabled) {
      border-color: $border--hover;
    }

    &--clickable {
      cursor: pointer;
    }

    &--joined {
      border-radius: 0;
      background: $mid-grey;
      border: 3px solid $mid-grey;
      border-left-width: 0;
      height: $large-size;
      min-height: $large-size;

      &:first-of-type {
        border-top-left-radius: $joined-border-radius;
        border-bottom-left-radius: $joined-border-radius;
        border-left-width: 3px;
      }

      &:last-of-type {
        border-top-right-radius: $joined-border-radius;
        border-bottom-right-radius: $joined-border-radius;
      }
    }

    &--joined#{&}:hover:not(&--selected):not(&--disabled) {
      background: color.adjust($mid-grey, $lightness: -5%);
      border-color: color.adjust($mid-grey, $lightness: -5%);
    }

    &--small {
      font-size: $font-size-small-softphone;
      padding: $vertical-padding--small $horizontal-padding;
      height: $small-size;
      min-height: $small-size;
    }

    &--selected {
      background: $background--selected;
      border-color: $border--selected;
    }

    &--selected#{&}--joined {
      background: $white;
      border-color: $mid-grey;

      > svg {
        color: $primary;
      }
    }

    &--disabled {
      opacity: 0.5;
    }

    &--icon-only:not(&--square) {
      width: $large-size;
      min-width: $large-size;
    }

    &--icon-only#{&}--small:not(&--square) {
      width: $small-size;
      min-width: $small-size;
    }

    &--small.segmented-controls__option--icon-only {
      height: $small-size;
      min-height: $small-size;
      width: $small-size;
      min-width: $small-size;
    }
  }

  &--inverse {
    border-radius: 8px;
  }

  &--inverse &__option {
    background: inherit;
    border: unset;
  }

  &--inverse &__option--selected {
    > svg {
      color: $primary;
    }
  }

  &--square &__option {
    border-radius: 4px;
    padding: 14px;
  }
}
